import { render, staticRenderFns } from "./JobStatusRelationList.vue?vue&type=template&id=6c1aa27b&"
import script from "./JobStatusRelationList.vue?vue&type=script&lang=js&"
export * from "./JobStatusRelationList.vue?vue&type=script&lang=js&"
import style0 from "./JobStatusRelationList.vue?vue&type=style&index=0&id=6c1aa27b&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports